(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/divider/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/modules/divider/assets/javascripts/index.js');

'use strict';

svs = svs || {};
svs.content = svs.content || {};
svs.content.divider = svs.content.divider || {};
svs.content.divider.link = function (e) {
  e.preventDefault();
  var url = e.currentTarget.href;
  trackClick(e.currentTarget, function () {
    window.location.href = url;
  });
};
function trackClick(el, callback) {
  var $el = $(el);
  var track = $el.data('track');
  var areaName = $el.data('areaName') || 'unknown';
  if (track && svs.components.analytics.trackPromoClick) {
    svs.components.analytics.trackPromoClick({
      id: track,
      name: track,
      position: areaName
    }, callback);
  } else {
    callback();
  }
}
if (svs.core.detect.feature('ft-divider-version-2')) {
  svs.content.divider.script = new svs.content.divider.V2();
} else {
  svs.content.divider.script = new svs.content.divider.V1();
}
svs.content.divider.script.init();
var links = document.querySelectorAll('.js-divider-link');
links.forEach(function (link) {
  link.addEventListener('click', svs.content.divider.link);
});

 })(window);